import ApiResourceManager from '../ApiResourceManager';

export default class PartnerLicenseProductsManager extends ApiResourceManager {
  /**
   * Self-service: the partner's own resolved price book (only products with
   * a usable price — the master default list is never exposed). Partner
   * admins are pinned to their provider by the on-behalf middleware.
   */
  get = () =>
    this.request({
      method: 'GET',
      url: '/partner-license-products',
    });
}
